import {
    getAddMessage,
    getCharMaxMessage,
    getCharMinMessage
} from '../../utils/formValidation/errorMessageFunctions';

const MIN_TITLE_LENGTH = 5;
const MAX_TITLE_LENGTH = 50;
const MIN_DESCRIPTION_LENGTH = 5;
const MAX_DESCRIPTION_LENGTH = 250;

export const validate = (survey) => {
    let newErrors = {};

    if (survey.title.length < MIN_TITLE_LENGTH) {
        newErrors = {
            ...newErrors,
            surveyTitle: {
                error: true,
                message: getCharMinMessage('Form title', MIN_TITLE_LENGTH)
            }
        };
    } else if (survey.title.length > MAX_TITLE_LENGTH) {
        newErrors = {
            ...newErrors,
            surveyTitle: {
                error: true,
                message: getCharMaxMessage('Form title', MAX_TITLE_LENGTH)
            }
        };
    }

    if (survey.description.length < MIN_DESCRIPTION_LENGTH) {
        newErrors = {
            ...newErrors,
            surveyDescription: {
                error: true,
                message: getCharMinMessage('Form description', MIN_DESCRIPTION_LENGTH)
            }
        };
    } else if (survey.description.length > MAX_DESCRIPTION_LENGTH) {
        newErrors = {
            ...newErrors,
            surveyDescription: {
                error: true,
                message: getCharMaxMessage('Form description', MAX_DESCRIPTION_LENGTH)
            }
        };
    }

    if (survey.pages?.length < 1) {
        newErrors = {
            ...newErrors,
            surveyPages: {
                error: true,
                message: getAddMessage('question')
            }
        };
    }

    survey.pages.forEach((el, i) => {
        if (el.title.length < MIN_TITLE_LENGTH) {
            newErrors = {
                ...newErrors,
                [`pageTitle-${i + 1}`]: {
                    error: true,
                    message: getCharMinMessage(`Form page ${i + 1} title`, MIN_TITLE_LENGTH)
                }
            };
        } else if (el.title.length > MAX_TITLE_LENGTH) {
            newErrors = {
                ...newErrors,
                [`pageTitle-${i + 1}`]: {
                    error: true,
                    message: getCharMaxMessage(`Form page ${i + 1} title`, MAX_TITLE_LENGTH)
                }
            };
        }

        if (el.description.length < MIN_DESCRIPTION_LENGTH) {
            newErrors = {
                ...newErrors,
                [`pageDescription-${i + 1}`]: {
                    error: true,
                    message: getCharMinMessage(
                        `Form page ${i + 1} description`,
                        MIN_DESCRIPTION_LENGTH
                    )
                }
            };
        } else if (el.description.length > MAX_DESCRIPTION_LENGTH) {
            newErrors = {
                ...newErrors,
                [`pageDescription-${i + 1}`]: {
                    error: true,
                    message: getCharMaxMessage(
                        `Form page ${i + 1} description`,
                        MAX_DESCRIPTION_LENGTH
                    )
                }
            };
        }

        if (el?.questions.length < 1) {
            newErrors = {
                ...newErrors,
                [`page-${i + 1}-questions`]: {
                    error: true,
                    message: getAddMessage(`question to page ${i + 1}`)
                }
            };
        }
    });

    return newErrors;
};
